<div class="flip-box-front" appDraggable>
  <div class="modal-header">

    <div class="row w-100">
      <div class="col-4 d-flex align-items-center">
        <b class="text-nowrap">Swap-Lending:</b>

        <ng-select [items]="Tenors"
                   [hideSelected]="true"
                   [searchable]="false"
                   [clearable]="false"
                   (ngModelChange)="tradeTypeChange.emit($event);changeSwapRate(null, 'INPUT', $event)"
                   bindLabel="name"
                   bindValue="value"
                   class="tenors-dropdown"
                   [(ngModel)]="selectedTenorId">
          <ng-template ng-option-tmp let-item="item">{{item.value | translate }}</ng-template>
        </ng-select>

      </div>

      <div class="col-4 text-center">
        <h3 class="modal-title">{{'buttonBorrow' | translate}}/{{'buttonLend' | translate}}
          <span (click)="flipModal()" name="frontFlip">{{currencyPairData.instrument.termCcy}}</span>
        </h3>
      </div>

      <div class="col-2 currMarket d-flex justify-content-end align-items-center" *ngIf="getCurrentMarket()">
        <div>
          {{getFormattedSpotPrice(false) | number:'1.0'}}<span *ngIf="getFormattedSpotPrice(true)">.{{getFormattedSpotPrice(true)}}</span>
        </div>
      </div>

      <div class="col-2 d-flex justify-content-end align-items-center" *ngIf="!getCurrentMarket()">—</div>

      <div class="col-2 d-flex justify-content-end align-items-center">
        <button class="close btn" (click)="close()">
<!--          <i class="fa fa-window-close fa-2x"></i>-->
          <i class="fa fa-times fa-2x"></i>
        </button>
      </div>


      <div class="col-8">
        <label class="check d-inline-block" *ngIf="isSuperUser">
          <input
            tabindex="-1"
            type="checkbox"
            class="custom-control-input"
            [(ngModel)]="previousSessionDate"
            (ngModelChange)="changeDates()"
          />
          <span class="checkmark"></span>
          <b translate>labelPrevSessionDate</b>
        </label>
      </div>

      <div class="col-4 pt-5 align-items-end" *ngIf="isSuperUser">
        <ng-select [items]="counterPartyUsers"
                   [hideSelected]="true"
                   [placeholder]="'Select a counter party'"
                   [searchable]="true"
                   [clearable]="false"
                   bindLabel="username"
                   bindValue="id"
                   class="custom-select mt-3"
                   [(ngModel)]="selectedCounterPartyId">
          <ng-template ng-option-tmp let-item="item">{{item.username | translate }}</ng-template>
        </ng-select>
      </div>

    </div>
  </div>
  <!--MODAL HEADER END  -->

  <div class="modal-body">
    <div class="row">
      <div class="col-2 d-flex align-items-center">
        <button id="changeDirectionBtn" type="button" class="btn btn-warning" tabindex="-1" (click)="changeDirection()">{{trade.direction | translate}}</button>
      </div>

      <div class="col-2 d-flex align-items-center justify-content-between font-weight-bold text-center text-nowrap h4">
        {{trade.sixLetterCode | getSecondCC}} {{'labelVs' | translate}}
      </div>

      <div class="col-6 align-self-center">
        <angular2-multiselect id="currencySelector"
                              [data]="dropdownList"
                              [(ngModel)]="selectedItems"
                              [settings]="dropdownSettings"
                              (onSelect)="onItemSelect($event)"
                              (onDeSelect)="OnItemDeSelect($event)"
                              (onSelectAll)="onSelectAll($event)"
                              (onDeSelectAll)="onDeSelectAll($event)"
                              (onOpen)="filterBaseCurrency()"
                              #multiSelectFront name="currencySelector">
          <c-item>
            <ng-template let-item="item">
              <label id="{{'additionalCurrency_' + item.ccy}}">{{item.itemName}}</label>
            </ng-template>
          </c-item>
        </angular2-multiselect>
      </div>

      <div class="col-2 d-flex justify-content-end">
        <label class="check d-inline-block">
          <input
            tabindex="-1"
            type="checkbox"
            class="custom-control-input"
            [(ngModel)]="isOcoActive"
            (ngModelChange)="reloadDropdownSettings()"
          />
          <span id="ocoCheckbox" class="checkmark"></span>
          <b>OCAO</b>
        </label>
      </div>

    </div>

    <!--  table block -------------------- -->
    <div class="modalTable">

      <!-- table header-------------------------------------------------- -->
      <div class="row modalTableHeader pb-4">
        <div class="col-3">Qty</div>
        <div class="col-3">{{'labelAmnt' | translate}}</div>
        <div class="col-2">&#64;</div>
        <div class="col-2">Factor</div>
        <div class="col-2">eq. %</div>
      </div>

      <div class="modalTableScroll">

        <!-- FIRST ROW -------------------------------------------------- -->
        <div class="row first-line">
          <!--             (click)="setBaseOrderToRangeSlider()"-->
          <!-- Qty-------------------------------------------------- -->
          <div class="flex-nowrap col-3">
            <div class="input-group input-group-sm flex-nowrap">
              <input [textMask]="{mask: qmask}" [(ngModel)]="trade.quantity" id="quantity" (ngModelChange)="calculateAmount()" (focus)="selectEvent($event)" class="form-control form-control-sm">
              <div class="input-group-append">
                <span class="input-group-text">{{trade.sixLetterCode | getFirstCC}}</span>
              </div>
            </div>
          </div>

          <!-- Amnt-------------------------------------------------- -->
          <div class="flex-nowrap col-3">
            <div class="input-group input-group-sm flex-nowrap">
              <input class="form-control form-control-sm" [textMask]="{mask: amask}" [(ngModel)]="amount" (ngModelChange)="calculateQuantityByAmount($event)" (focusout)="calculateAmount()">
              <div class="input-group-append">
                <span class="input-group-text">{{currencyPairData.instrument.termCcy}}</span>
              </div>
            </div>
          </div>

          <!-- @ -------------------------------------------------- -->
          <div class="flex-nowrap col-2">
            <div class="input-group input-group-sm flex-nowrap">
              <input
                name="swapPrice"
                [(ngModel)]="price"
                (ngModelChange)="changeSwapRate($event, 'INPUT')"
                [textMask]="{mask: mask}"
                class="form-control"
                (click)="selectEvent($event)"
                autocomplete="off" />
            </div>
          </div>

          <!-- Factor -------------------------------------------------- -->
          <div class="col mt-2 factor">
            x{{swapPriceFactor | number}}
          </div>

          <!-- eq -------------------------------------------------- -->
          <div class="flex-nowrap col-2">
            <div class="input-group input-group-sm col flex-nowrap">
              <input [textMask]="{mask: rmask}" name="swapRate" [(ngModel)]="swapRate" class="form-control" (ngModelChange)="changePrice()" (focus)="selectEvent($event)" (keydown)="validateTradeKeyPress($event)">
            </div>
          </div>

        </div>

        <!-- OCO ROWS -------------------------------------------------- -->
        <div>
          <div class="row ocoact" *ngFor="let oco of ocos">
            <!--                 (click)="setOcoToRangeSlider(oco)"-->

            <!-- Qty-------------------------------------------------- -->
            <div class="flex-nowrap col-3">
              <div class="input-group input-group-sm flex-nowrap">
                <input [textMask]="{mask: qmask}" [(ngModel)]="oco.quantity" disabled class="form-control form-control-sm">
                <div class="input-group-append">
                  <span class="input-group-text">{{oco.sixLetterCode | getFirstCC}}</span>
                </div>
              </div>
            </div>


            <!-- Amnt-------------------------------------------------- -->
            <div class="flex-nowrap col-3">
              <div class="input-group input-group-sm flex-nowrap">
                <input class="form-control form-control-sm" [textMask]="{mask: amask}" [(ngModel)]="amount" disabled>
                <div class="input-group-append">
                  <!--                <span class="input-group-text">{{oco.sixLetterCode | getSecondCC}}</span>-->
                  <span class="input-group-text">{{currencyPairsJson[oco.sixLetterCode].instrument.termCcy}}</span>
                </div>
              </div>
            </div>

            <!-- @ -------------------------------------------------- -->
            <div class="flex-nowrap col-2">
              <div class="input-group input-group-sm flex-nowrap">
                <input
                  [(ngModel)]="oco.swapPrice"
                  (ngModelChange)="changeOcoSwapRate(oco)"
                  [textMask]="{mask: getNumberMask(oco.sixLetterCode)}"
                  class="form-control"
                  (click)="selectEvent($event)"
                  autocomplete="off"/>
              </div>
            </div>

            <!-- Factor -------------------------------------------------- -->
            <div class="col-2 mt-2 factor">
              x{{getCpFactor(oco.sixLetterCode)}}
            </div>

            <!-- eq -------------------------------------------------- -->
            <div class="flex-nowrap col-2">

              <div class="input-group input-group-sm flex-nowrap">
                <input [textMask]="{mask: rmask}" [(ngModel)]="oco.swapRate" class="form-control" (ngModelChange)="changeOcoSwapPrice(oco)" (focus)="selectEvent($event)">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ROWS END ---------- -->
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-between" (window:keypress)="front ? keyUpEnter($event) : ''">

    <button type="button" tabindex="-1" class="btn btn-outline-primary" (click)="showDetails()">
      <i [ngClass]="detailStatus ? 'fa fa-angle-up' : 'fa fa-angle-down'" aria-hidden="true"></i>
      {{'buttonDetails' | translate}}
    </button>

    <span *ngIf="daysDifferenceBtwNearlegAndFarlegDate === 3 && selectedTenorId === 1">
      NOTE! O/N: Fri - Mon = 3 days
    </span>

    <button type="button" name="sendOrder" tabindex="-1" *ngIf="!detailStatus" class="btn btn-primary" (click)="sendOrder()">
      <i class="fa fa-angle-right" aria-hidden="true"></i> {{'buttonSendOrder' | translate}}
    </button>

    <button type="button" name="sendOrder" tabindex="-1" style="visibility: hidden" *ngIf="detailStatus" class="btn btn-primary" (click)="sendOrder()">
      <i class="fa fa-angle-right" aria-hidden="true"></i> {{'buttonSendOrder' | translate}}
    </button>
  </div>
  <div [isOpened]="detailStatus" [detailsTemplate]="details"></div>

  <!--  RANGE SLIDER ------------------------------------------- -->
  <ng-template #details>
    <div class="orderDetails" [@detailExpand]>
      <div class="row">
        <div class="col-9">
          <app-range-slider [trade]="trade"
                            (ngModelChange)="changeSwapRate($event, 'SLIDER')"
                            *ngIf="trade.direction === 'BORROW'"
                            [max]="rangeSliderMaxPrice"
                            [min]="rangeSliderMinPrice"
                            [active]="front"
                            [(ngModel)]="rangeSliderPrice"></app-range-slider>

          <app-range-slider [trade]="trade"
                            (ngModelChange)="changeSwapRate($event, 'SLIDER')"
                            *ngIf="trade.direction === 'LEND'"
                            [max]="rangeSliderMaxPrice"
                            [min]="rangeSliderMinPrice"
                            [active]="front"
                            [(ngModel)]="rangeSliderPrice"></app-range-slider>
        </div>
      </div>

      <div class="row ml-3 mr-3 mb-3 sampleTrade">
        <div class="col-2 d-flex align-items-center">
          <b>Sample Trade</b>
        </div>

        <div class="col-7">
          <div class="table-sample">
            <table class="table-bordered">
              <thead>
              <tr>
                <th scope="col" class="double-right"></th>
                <th scope="col" class="same-with-col"><b>{{trade.direction === 'LEND' ? 'BUY' : 'SELL'}}</b><br>{{(trade.sixLetterCode | getFirstCC) + '/' + (trade.sixLetterCode | getSecondCC)}}</th>
                <th scope="col" class="same-with-col"><b>{{trade.direction === 'BORROW' ? 'BUY' : 'SELL'}}</b><br>{{(trade.sixLetterCode | getFirstCC) + '/' + (trade.sixLetterCode | getSecondCC)}}</th>
                <th scope="col" class="same-with-col"></th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th scope="row" class="double-right no-border-left">Curr</th>
                <td class="text-center">{{nearLegDate | date:'dd MMM.'}}</td>
                <td class="text-center">{{getTradeValueDate() | date:'dd MMM.'}}</td>
                <td></td>
              </tr>
              <tr>
                <th scope="row" class="double-right no-border-left">{{currencyPairData.instrument.baseCcy}} </th>
                <td class="text-right sameWidthCol">{{trade.direction === 'LEND' ? '+1' : '-1'}}</td>
                <td class="text-right sameWidthCol">{{trade.direction === 'BORROW' ? '+1' : '-1'}}</td>
                <td>{{(trade.direction === 'LEND' && getMaskedPriceAsNumber() > 0) || (trade.direction === 'BORROW' && getMaskedPriceAsNumber() < 0) ? ('labelEarning' | translate) : ('labelCost' | translate)}}
                  <i class="fa fa-long-arrow-down" aria-hidden="true"></i></td>
              </tr>
              <tr>
                <th scope="row" class="double-right no-border-left">{{currencyPairData.instrument.termCcy}}</th>
                <td class="text-right active sameWidthCol">{{trade.direction === 'LEND' ? (trade.currentMarket * -1 | number:'1.0') : ('+' + (trade.currentMarket | number:'1.0'))}}</td>
                <td class="text-right sameWidthCol">{{trade.direction === 'BORROW' ? ((trade.currentMarket + (getMaskedPriceAsNumber() | priceFactorPipe: trade.sixLetterCode: true)) *-1 | number:'1.0') : ('+' + (trade.currentMarket + (getMaskedPriceAsNumber() | priceFactorPipe: trade.sixLetterCode: true) | number:'1.0'))}}</td>
                <td>{{(currencyPairData.instrument.termCcy) | getCurrencySymbol}}{{Math.abs(getMaskedPriceAsNumber() | priceFactorPipe: trade.sixLetterCode: true) | number:'1.0'}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-3 d-flex align-content-end justify-content-end">
          <div class="align-self-end">
            <button name="sendOrder" type="button" tabindex="-1" class="btn btn-primary" (click)="sendOrder()">
              <i class="fa fa-angle-right" aria-hidden="true"></i> {{'buttonSendOrder' | translate}}
            </button>
          </div>
        </div>

      </div>
    </div>
  </ng-template>
</div>

<!--FLIP BOX BACK--------------------------------------------------------------- -->
<div class="flip-box-back" appDraggable>
  <div class="modal-header">

    <div class="row w-100">
      <div class="col-4 d-flex align-items-center">
        <b>Swap-Lending:</b>
        <ng-select [items]="Tenors"
                   [hideSelected]="true"
                   [searchable]="false"
                   [clearable]="false"
                   (ngModelChange)="changeSwapRate(null, 'INPUT', $event)"
                   bindLabel="name"
                   bindValue="value"
                   class="tenors-dropdown"
                   [(ngModel)]="selectedTenorId">
          <ng-template ng-option-tmp let-item="item">{{item.value | translate}}</ng-template>
        </ng-select>
      </div>

      <div class="col-4 text-center">
        <h3 class="modal-title">{{'buttonBorrow' | translate}}/{{'buttonLend' | translate}}
          <span (click)="flipModalBack()" name="frontFlipBack">{{currencyPairData.instrument.baseCcy}}</span>
        </h3>
      </div>

      <div class="col-2 currMarket d-flex justify-content-end align-items-center" *ngIf="getCurrentMarket()">
        <div>
          {{getFormattedSpotPrice(false) | number:'1.0'}}<span *ngIf="getFormattedSpotPrice(true)">.{{getFormattedSpotPrice(true)}}</span>
        </div>
      </div>

      <div class="col-2 d-flex justify-content-end align-items-center" *ngIf="!getCurrentMarket()">—</div>
      <div class="col-2 d-flex justify-content-end align-items-center">
        <button class="close btn" (click)="close()">
          <i class="fa fa-times fa-2x"></i>
        </button>
      </div>
<!--      <div class="col-2">-->
<!--        <button type="button" class="close" (click)="close()">-->
<!--          <i class="fa fa-times"></i>-->
<!--        </button>-->
<!--      </div>-->

      <div class="col-12 d-flex justify-content-between">
        <label class="check d-inline-block" *ngIf="isSuperUser">
          <input
            tabindex="-1"
            type="checkbox"
            class="custom-control-input"
            [(ngModel)]="previousSessionDate"
            (ngModelChange)="changeDates()"
          />
          <span class="checkmark"></span>
          <b translate>labelPrevSessionDate</b>
        </label>

        <div *ngIf="!isSuperUser"></div>

        <div class="col-4 pt-5 align-items-end" *ngIf="isSuperUser">
          <ng-select [items]="counterPartyUsers"
                     [hideSelected]="true"
                     [placeholder]="'Select a counter party'"
                     [searchable]="true"
                     [clearable]="true"
                     bindLabel="username"
                     bindValue="id"
                     class="custom-select mt-3"
                     [(ngModel)]="selectedCounterPartyId">
            <ng-template style="right: 0" ng-option-tmp let-item="item">{{item.username | translate }}</ng-template>
          </ng-select>
        </div>
      </div>

    </div>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-2 d-flex align-items-center">
        <button id="changeDirectionBtnBack" type="button" class="btn btn-warning" tabindex="-1" (click)="changeDirection()">{{trade.direction | translate}}</button>
      </div>

      <div class="col-2 d-flex align-items-center justify-content-between font-weight-bold text-center text-nowrap h4">
        {{trade.sixLetterCode | getFirstCC}}  {{'labelVs' | translate}}
      </div>

      <div class="col-6 align-self-center">
        <angular2-multiselect id="currencySelectorBack"
                              [data]="dropdownListBack"
                              [(ngModel)]="selectedItemsBack"
                              tabindex="3"
                              [settings]="dropdownSettings"
                              (onSelect)="onItemSelectBack($event)"
                              (onDeSelect)="OnItemDeSelectBack($event)"
                              (onSelectAll)="onSelectAll($event)"
                              (onOpen)="filterBaseCurrencyOnBackSide()"
                              (onDeSelectAll)="onDeSelectAll($event)"
                              #multiSelectBack

        >
          <c-item>
            <ng-template let-item="item">
              <label id="{{'additionalCurrency_' + item.ccy}}">{{item.itemName}}</label>
            </ng-template>
          </c-item>
        </angular2-multiselect>
      </div>

      <div class="col-2 d-flex justify-content-end">
        <label class="check d-inline-block">
          <input
            tabindex="-1"
            type="checkbox"
            class="custom-control-input"
            [(ngModel)]="isOcoActiveBack"
            (ngModelChange)="reloadDropdownSettings(true)"
          />
          <span id="ocoCheckboxBack" class="checkmark"></span>
          <b>OCAO</b>
        </label>
      </div>

    </div>

    <!--  table block -------------------- -->
    <div class="modalTable">

      <!-- table header-------------------------------------------------- -->
      <div class="row modalTableHeader pb-4">
        <div class="col-3">Qty</div>
        <div class="col-3">{{'labelAmnt' | translate}}</div>
        <div class="col-2">&#64;</div>
        <div class="col-2">Factor</div>
        <div class="col-2">eq. %</div>
      </div>

      <div class="modalTableScroll">

        <!-- FIRST ROW -------------------------------------------------- -->
        <div class="row first-line">
          <!-- Qty-------------------------------------------------- -->
          <div class="flex-nowrap col-3">
            <div class="input-group input-group-sm flex-nowrap">
              <input [textMask]="{mask: qmask}" [(ngModel)]="trade.quantity" id="quantityBack" (ngModelChange)="calculateAmount()" (focus)="selectEvent($event)" class="form-control form-control-sm">
              <div class="input-group-append">
                <span class="input-group-text">{{trade.sixLetterCode | getFirstCC}}</span>
              </div>
            </div>
          </div>

          <!-- Amnt-------------------------------------------------- -->
          <div class="flex-nowrap col-3">
            <div class="input-group input-group-sm flex-nowrap">
              <input class="form-control form-control-sm" [textMask]="{mask: amask}" [(ngModel)]="amount" disabled>
              <div class="input-group-append">
                <span class="input-group-text">{{currencyPairData.instrument.termCcy}}</span>
              </div>
            </div>
          </div>

          <!-- @ -------------------------------------------------- -->
          <div class="col-2 flex-nowrap">
            <div class="input-group input-group-sm">
              <input
                id="swapPriceBack"
                [(ngModel)]="price"
                (ngModelChange)="changeSwapRate($event, 'INPUT')"
                [textMask]="{mask: mask}"
                class="form-control"
                (click)="selectEvent($event)"
                autocomplete="off" />
            </div>
          </div>

          <!-- Factor -------------------------------------------------- -->
          <div class="col-2 mt-2 factor">
            x{{swapPriceFactor}}
          </div>

          <!-- eq -------------------------------------------------- -->
          <div class="col-2 flex-nowrap">
            <div class="input-group input-group-sm">
              <input [textMask]="{mask: rmask}"  [(ngModel)]="swapRate" id="swapRateBack" class="form-control" (ngModelChange)="changePrice()" (focus)="selectEvent($event)" (keydown)="validateTradeKeyPress($event)">
            </div>
          </div>

        </div>

        <!-- OCO ROWS -------------------------------------------------- -->
        <div>
          <div class="row ocoact" *ngFor="let oco of ocosBack">

            <!-- Qty-------------------------------------------------- -->
            <div class="flex-nowrap col-3">
              <div class="input-group input-group-sm flex-nowrap">
                <input [textMask]="{mask: qmask}" [(ngModel)]="trade.quantity" disabled class="form-control form-control-sm">
                <div class="input-group-append">
                  <span class="input-group-text">{{currencyPairsJson[oco.sixLetterCode].instrument.baseCcy}}</span>
                </div>
              </div>
            </div>

            <!-- Amnt-------------------------------------------------- -->
            <div class="flex-nowrap col-3">
              <div class="input-group input-group-sm flex-nowrap">
                <input class="form-control form-control-sm" [textMask]="{mask: amask}" [(ngModel)]="oco.amount" disabled>
                <div class="input-group-append">
                  <span class="input-group-text">{{currencyPairsJson[oco.sixLetterCode].instrument.termCcy}}</span>
                </div>
              </div>
            </div>

            <!-- @ -------------------------------------------------- -->
            <div class="col-2 flex-nowrap">
              <div class="input-group input-group-sm flex-nowrap">
                <input
                  [(ngModel)]="oco.swapPrice"
                  (ngModelChange)="changeOcoSwapRate(oco)"
                  [textMask]="{mask: getNumberMask(oco.sixLetterCode)}"
                  class="form-control"
                  (click)="selectEvent($event)"
                  autocomplete="off"/>
              </div>
            </div>

            <!-- Factor -------------------------------------------------- -->
            <div class="col-2 mt-2 factor">
              x{{getCpFactor(oco.sixLetterCode)}}
            </div>

            <!-- eq -------------------------------------------------- -->
            <div class="col-2 flex-nowrap">
              <div class="input-group input-group-sm">
                <input [textMask]="{mask: rmask}" [(ngModel)]="oco.swapRate" class="form-control" (ngModelChange)="changeOcoSwapPrice(oco)" (focus)="selectEvent($event)">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ROWS END ---------- -->
    </div>
  </div>


  <div class="modal-footer d-flex justify-content-between" (window:keypress)="!front ? keyUpEnter($event) : ''">

    <button type="button" tabindex="-1" class="btn btn-outline-primary" (click)="showDetails()">
      <i [ngClass]="detailStatus ? 'fa fa-angle-up' : 'fa fa-angle-down'" aria-hidden="true"></i>
      {{'buttonDetails' | translate}}
    </button>

    <span *ngIf="daysDifferenceBtwNearlegAndFarlegDate === 3 && selectedTenorId === 1">
      NOTE! O/N: Fri - Mon = 3 days
    </span>

    <button name="sendOrder" id="sendOrder" type="button" tabindex="-1" *ngIf="!detailStatus" class="btn btn-primary" (click)="sendInvertedOrder()">
      <i class="fa fa-angle-right" aria-hidden="true"></i> {{'buttonSendOrder' | translate}}
    </button>

    <button type="button" tabindex="-1" style="visibility: hidden" *ngIf="detailStatus" class="btn btn-primary">
      <i class="fa fa-angle-right" aria-hidden="true"></i> {{'buttonSendOrder' | translate}}
    </button>
  </div>

  <div [isOpened]="detailStatus" [detailsTemplate]="details2"></div>

  <ng-template #details2>
    <!--  RANGE SLIDER ------------------------------------------- -->
    <div class="orderDetailsBack" [@detailExpand]>

      <div class="row">
        <div class="col-9">
          <app-range-slider [trade]="trade" (ngModelChange)="changeSwapRate($event, 'SLIDER')" *ngIf="trade.direction === 'BORROW'" [active]="!front"
                            [max]="rangeSliderMaxPriceBack"
                            [min]="rangeSliderMinPriceBack"
                            [(ngModel)]="rangeSliderPriceBack"></app-range-slider>
          <app-range-slider [trade]="trade" (ngModelChange)="changeSwapRate($event, 'SLIDER')" *ngIf="trade.direction === 'LEND'" [active]="!front"
                            [max]="rangeSliderMaxPriceBack"
                            [min]="rangeSliderMinPriceBack"
                            [(ngModel)]="rangeSliderPriceBack"></app-range-slider>
        </div>

        <div class="col-3 inverted-txt">
          <b>Prices inverted<br>only for display</b>
        </div>

      </div>



      <div class="row ml-3 mr-3 mb-3 sampleTrade">
        <div class="col-2 d-flex align-items-center">
          <b>Sample Trade</b>
        </div>

        <div class="col-7">
          <div class="table-sample">
            <table class="table-bordered">
              <thead>
              <tr>
                <th scope="col" class="double-right"></th>
                <th scope="col" class="same-with-col"><b>{{trade.direction === 'BORROW' ? 'BUY' : 'SELL'}}</b><br>{{currencyPairData.instrument.name}}</th>
                <th scope="col" class="same-with-col"><b>{{trade.direction === 'LEND' ? 'BUY' : 'SELL'}}</b><br>{{currencyPairData.instrument.name}}</th>
                <th scope="col" class="same-with-col"></th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th scope="row" class="double-right no-border-left">Curr</th>
                <td class="text-center">{{nearLegDate | date:'dd MMM.'}}</td>
                <td class="text-center">{{getTradeValueDate() | date:'dd MMM.'}}</td>
                <td></td>
              </tr>
              <tr>
                <th scope="row" class="double-right no-border-left">{{currencyPairData.instrument.baseCcy}} </th>
                <td class="text-right active sameWidthCol">{{trade.direction === 'BORROW' ? '+1' : '-1'}}</td>
                <td class="text-right sameWidthCol">{{trade.direction === 'LEND' ? '+1' : '-1'}}</td>
                <td>{{(trade.direction === 'LEND' && getMaskedPriceAsNumber() < 0) || (trade.direction === 'BORROW' && getMaskedPriceAsNumber() > 0) ? ('labelCost' | translate) : ('labelEarning' | translate)}}
                  <i class="fa fa-long-arrow-down" aria-hidden="true"></i>
                </td>
              </tr>
              <tr>
                <th scope="row" class="double-right no-border-left">{{currencyPairData.instrument.termCcy}}</th>
                <td class="text-right sameWidthCol">{{trade.direction === 'BORROW' ? (trade.currentMarket * -1 | number:'1.0') : ('+' + (trade.currentMarket | number:'1.0'))}}</td>
                <td class="text-right sameWidthCol">{{trade.direction === 'LEND' ? (((trade.currentMarket * -1) + (price | priceFactorPipe: trade.sixLetterCode: true) | number:'1.0')) : ('+' + ((trade.currentMarket + (getMaskedPriceAsNumber() | priceFactorPipe: trade.sixLetterCode: true)) | number:'1.0'))}}</td>
                <td>{{(currencyPairData.instrument.termCcy) | getCurrencySymbol}}{{Math.abs(getMaskedPriceAsNumber() | priceFactorPipe: trade.sixLetterCode: true) | number:'1.0'}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-3 d-flex align-content-end justify-content-end">
          <div class="align-self-end">
            <button id="sendOrder" type="button" tabindex="-1" class="btn btn-primary" (click)="sendInvertedOrder()">
              <i class="fa fa-angle-right" aria-hidden="true" name="sendOrderDetailBack"></i> {{'buttonSendOrder' | translate}}
            </button>
          </div>
        </div>

      </div>
    </div>
  </ng-template>
</div>
